/**
 * Account page - canonical S018 my-profile screen.
 * 
 * ACT-INDEEP-FRONTEND-FIGMA-S018-MY-PROFILE01
 * 
 * Route contract:
 * - anonymous → ProtectedRoute blocks access
 * - authenticated unclassified → redirect to /profile-completion
 * - authenticated friend/sponsor → render MyProfilePage
 * 
 * Privacy doctrine:
 * - No legal name, government ID, or address collection
 * - No raw account ID display
 * - No session tokens or identifiers exposed
 * - Logout uses existing production auth boundary
 */
import { Navigate } from 'react-router-dom';
import { MyProfilePage } from '@/features/my-profile/MyProfilePage';
import { RoutePaths } from '@/routes';
import { useAuthStore } from '@/store/authStore';

/**
 * Account page with registration-kind guard.
 * 
 * P0: Unclassified accounts must be directed to profile completion,
 * not shown the profile page with fixture data.
 */
export function AccountPage() {
  const registrationKind = useAuthStore(
    (state) => state.registrationKind,
  );

  // P0: Redirect unclassified users to profile completion
  if (registrationKind === 'unclassified') {
    return (
      <Navigate
        to={RoutePaths.PROFILE_COMPLETION}
        replace
      />
    );
  }

  return <MyProfilePage />;
}
